export default {"src":"/_next/static/media/progress-icon.29658b7b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};